// Constants
import {
  ELIGIBILITY_TYPE,
  ELIGIBILITY_TYPE_LABEL,
  PERK_TYPES,
} from "~constants/perks"

import { getFullImagePath } from "~utils/utils"

// Utils
import { createDropdownValue, SelectOption } from "~utils/dropdown"
import {
  getRulesLogic,
  eligibilityRulesParser,
  getInitialHoldingsRulesLogic,
  getPeriodUnit,
} from "~utils/eligibilityRulesPicker"

// Interfaces
import { CouponList } from "~shapes/coupon"
import { PerkShape, PerkRedemptionTypeShape } from "~shapes/perk"

export const step1PrefillValues = (
  perk: PerkShape,
  perkType: PerkRedemptionTypeShape,
) => {
  let prefill = {
    perkType: perkType
      ? createDropdownValue(PERK_TYPES[perkType.type], perkType.type)
      : null,
  }

  if (perk.company?.id) {
    prefill["company"] = createDropdownValue(perk.company.name, perk.company.id)
  }

  return prefill
}

export const step2PrefillValues = (perk: PerkShape) => ({
  name: perk.name,
  code: perk.code,
  shortDescription: perk.shortDescription,
  rules: perk.rules,
  redeemInstructions: perk.redeemInstructions,
  description: perk.description,
  successRedemptionTitle: perk.successRedemptionTitle,
  termsAndConditions: perk.termsAndConditions,
})

export const step3PrefillValues = (perk: PerkShape) => {
  let rules = eligibilityRulesParser(perk.eligibilityRules)
  rules.periodUnit = getPeriodUnit(rules)
  const ruleLogic: SelectOption = getRulesLogic(rules)
  const initialHoldingsRuleLogic: SelectOption =
    getInitialHoldingsRulesLogic(rules)
  const eligibilityTypeValue = rules.noHoldings
    ? ELIGIBILITY_TYPE.EVERYONE_ELIGIBLE
    : ELIGIBILITY_TYPE.SHARES_CONFIGURATION
  const eligibilityType: SelectOption = createDropdownValue(
    ELIGIBILITY_TYPE_LABEL[eligibilityTypeValue],
    eligibilityTypeValue,
  )
  return {
    ...rules,
    ruleLogic,
    initialHoldingsRuleLogic,
    eligibilityType,
  }
}

export const stepExternalLinkPrefillValues = (perk: PerkShape) => ({
  redeemResource: perk.redeemResource,
})

export const stepCouponListPrefillValues = (couponList: CouponList) => {
  const coupons = couponList._embedded.coupons
  const currentCouponsLength = couponList.page.totalElements

  const isUniqueCode = coupons.length === 1 && coupons[0].general
  const uniqueCode = isUniqueCode && coupons[0].code

  return {
    uniqueCode,
    isUniqueCode,
    currentCouponsLength,
    // Default to keeping the existing coupons untouched when editing, so the
    // user can move past this step without re-creating/re-uploading codes.
    skipCouponEdit: true,
  }
}

export const step5PrefillValues = (perk: PerkShape) => ({
  cover: perk.cover ? getFullImagePath(perk.cover) : null,
  logo: perk.logo ? getFullImagePath(perk.logo) : null,
})
